import { render, staticRenderFns } from "./DeckMobileNav.vue?vue&type=template&id=152e90ca"
import script from "./DeckMobileNav.vue?vue&type=script&lang=js"
export * from "./DeckMobileNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports